import Master from './Master.html';
import Login from './Login.html';
import HomePage from './HomePage.html';

import Profile from './Profile.html';
import ManageApplications from './ManageApplications.html';
import my_wills from './my_wills.html';
import ManageAdvisors from './ManageAdvisors.html';
import AdvisorGroups from './AdvisorGroups.html';
import ViewAdvisorGroup from './ViewAdvisorGroup.html';
import bulk_change_advisor from './bulk_change_advisor.html';
import AddApplication from './AddApplication.html';

import Reports from './Reports.html';
import rep_client_list from './rep_client_list.html';
import rep_advisor_client_list from './rep_advisor_client_list.html';
import Monthly_client_list from './Monthly_client_list.html';

import ManageUsers from './ManageUsers.html';
import AddUser from './AddUser.html';
import ViewUser from './ViewUser.html';
import VUt_Navigation from './VUt_Navigation.html';
import VUt_Organisations from './VUt_Organisations.html';
import VUt_Allocations from './VUt_Allocations.html';
import VUt_User_message from './VUt_User_message.html';
import VUt_User_commslog from './VUt_User_commslog.html';

import ManageOrganisation from './ManageOrganisation.html';
import AddOrganisation from './AddOrganisation.html';
import ViewOrganisation from './ViewOrganisation.html';

import ViewApplication from './ViewApplication.html';
import ViewAdvisor from './ViewAdvisor.html';
import ManageLeads from './ManageLeads.html';
import Dashboard from './Dashboard.html';
import dashboard_allocation from './dashboard_allocation.html';
import AddLead from './AddLead.html';
import ViewLead from './ViewLead.html';
import VLd_Details from './VLd_Details.html';
import VLd_ContactReports from './VLd_ContactReports.html';
import VAd_Details from './VAd_Details.html';
import VAd_ContactReports from './VAd_ContactReports.html';
import VAd_CommsLog from './VAd_CommsLog.html';
import VAd_WillsApplications from './VAd_WillsApplications.html';
import VUt_UserDetails from './VUt_UserDetails.html';
import VAt_Overview from './VAt_Overview.html';
import VAt_Client_Overview from './VAt_Client_Overview.html';
import VAt_AppDetails from './VAt_AppDetails.html';
import VAt_Will from './VAt_Will.html';
import VAt_Will_advisor from './VAt_Will_advisor.html';
import VAt_History from './VAt_History.html';
import VAt_Withdrawal from './VAt_Withdrawal.html';
import VAt_SummaryDocument from './VAt_SummaryDocument.html';
import VAt_Documentation from './VAt_Documentation.html';
import ADs_PersonalDetails from './ADs_PersonalDetails.html';
import ADs_MaritalStatus from './ADs_MaritalStatus.html';
import ADs_ChildrenDetails from './ADs_ChildrenDetails.html';
import ADs_Heirs from './ADs_Heirs.html';
import ADs_Trust from './ADs_Trust.html';
import ADs_Guardian from './ADs_Guardian.html';
import ADs_Equity from './ADs_Equity.html';
import ADs_Devise from './ADs_Devise.html';
import ADs_submit_advisor_review from './ADs_submit_advisor_review.html';
import Email_templates from './Email_templates.html';
import Email_template_detail from './Email_template_detail.html';
import wo_elements from './wo_elements.html';

export default {
  Master,
  Login,
  HomePage,
  Profile,
  Reports,
  rep_client_list,
  rep_advisor_client_list,
  Monthly_client_list,

  ManageOrganisation,
  AddOrganisation,
  ViewOrganisation,
  
  ManageUsers,
  AddUser,
  ViewUser,
  VUt_Navigation,
  VUt_Organisations,
  VUt_UserDetails,
  VUt_Allocations,
  VUt_User_message,
  VUt_User_commslog,
  
  ManageApplications,
  my_wills,
  my_will: my_wills,
  ManageAdvisors,
  AdvisorGroups,
  ViewAdvisorGroup,
  bulk_change_advisor,
  AddApplication,
  ViewApplication,
  ViewAdvisor,
  ManageLeads,
  Dashboard,
  dashboard_allocation,
  AddLead,
  ViewLead,
  VLd_Details,
  VLd_ContactReports,
  VAd_Details,
  VAd_ContactReports,
  VAd_CommsLog,
  VAd_WillsApplications,
  VAt_Overview,
  VAt_Client_Overview,
  VAt_Withdrawal,
  VAt_SummaryDocument,
  VAt_Documentation,
  VAt_History,
  VAt_AppDetails,
  ADs_PersonalDetails,
  ADs_MaritalStatus,
  ADs_ChildrenDetails,
  ADs_Devise,
  ADs_Heirs,
  ADs_Trust,
  ADs_Guardian,
  ADs_Equity,
  ADs_submit_advisor_review,
  VAt_Will,
  VAt_Will_advisor,
  Email_templates,
  Email_template_detail,
  wo_elements,
};
